import React from 'react'
import MaterialTable, { MTableToolbar } from '@material-table/core'
import DeleteIcon from '@material-ui/icons/Delete'
import { makeStyles, MuiThemeProvider } from '@material-ui/core/styles'
import { tableAlternateLight } from '../../services/theme'
import { Button, Typography, Card, CardContent, IconButton } from '@material-ui/core'
import { useSelector } from 'react-redux'
import moment from 'moment'
const useStyles = makeStyles((theme) => ({
	toolbar: {
		paddingLeft: 0
	}
}))

const HolidaysTable = (props) => {
	const classes = useStyles()

	const cellStyle = {
		paddingLeft: 0
	}
	let { setIsEditItemPopupShown, setSelectedItem, facility, setHolidayToDelete } = props

	return (
		<Card style={{ marginBottom: '48px' }}>
			<CardContent>
				<MuiThemeProvider theme={tableAlternateLight}>
					<MaterialTable
						isLoading={false}
						style={{
							borderRadius: '0px',
							boxShadow: 'none',
							borderBottom: '1px solid #D0CFD2',
							marginBottom: '16px'
						}}
						onRowClick={(e, h) => {
							console.log('on this end...', h)
							props.setHoliday(h)
						}}
						options={{
							headerStyle: {
								color: '#1A1A35',
								textTransform: 'uppercase',
								fontWeight: 800,
								fontSize: '12px',
								lineHeight: '16px',
								padding: '8px 0px',
								borderBottom: '1px solid #D0CFD2'
							},
							actionsColumnIndex: -1,
							rowStyle: {
								verticalAlign: 'top',
								backgroundColor: '#FFFFFF'
							},
							toolbarButtonAlignment: 'left',
							searchFieldAlignment: 'left',
							paging: false,
							search: false,
							actionsCellStyle: {
								// border: "none",
								padding: '6px 0px'
							}
						}}
						localization={{
							header: {
								actions: ''
							}
						}}
						actions={[{}]}
						columns={[
							{
								title: 'Date Range',
								field: 'name',
								cellStyle,
								render: (data) => {
									return (
										<div>
											<Typography variant="caption">
												{moment(data.startDate).format('MM/DD/YY')} -{' '}
												{moment(data.endDate).format('MM/DD/YY')}
											</Typography>
										</div>
									)
								}
							},
							{
								title: 'Title',
								field: 'name',
								cellStyle,
								render: (data) => {
									return (
										<div>
											<Typography variant="caption">{data.name}</Typography>
										</div>
									)
								}
							},
							{
								title: 'Surcharge Dates',
								field: 'quantity',
								cellStyle,
								render: (data) => {
									if (!data.surcharge_dates || !data.surcharge_dates.length) return null
									return (
										<div>
											<Typography variant="caption">
												{data.surcharge_dates
													.map((d) => moment(d, 'YYYY-MM-DD').format('MM/DD/YY'))
													.join(', ')}
											</Typography>
										</div>
									)
								}
							},
							{
								title: 'Surcharge Fee',
								field: 'price',
								cellStyle,

								render: (data) => {
									if (!data.surcharge_fee) return null
									return (
										<div>
											<Typography variant="caption">
												${(data.surcharge_fee / 100).toFixed(2)}
											</Typography>
										</div>
									)
								}
							},
							{
								title: 'Blocked Pick-up and Drop-off',
								field: 'quantity',
								cellStyle,
								render: (data) => {
									if (
										!data.restricted_pick_drop_dates ||
										!data.restricted_pick_drop_dates.length
									)
										return null
									return (
										<div>
											<Typography variant="caption">
												{data.restricted_pick_drop_dates
													.map((d) => moment(d, 'YYYY-MM-DD').format('MM/DD/YY'))
													.join(', ')}
											</Typography>
										</div>
									)
								}
							}
						]}
						components={{
							Toolbar: (props) => (
								<MTableToolbar
									{...props}
									classes={{
										root: classes.toolbar
									}}
								/>
							),
							Action: (props) => {
								return (
									<IconButton
										onClick={(e, row) => {
											e.stopPropagation()
											setHolidayToDelete(props.data)
										}}>
										<DeleteIcon fontSize="small" />
									</IconButton>
								)
							}
						}}
						data={props.holidays.filter(h => !!h.active)}
						title="HOLIDAYS"
					/>
				</MuiThemeProvider>
			</CardContent>
		</Card>
	)
}

export default HolidaysTable
